import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Form as Unform } from '@unform/web';

import { TextField, Button, LinearProgress, Grid } from '@material-ui/core';
import {
  Edit,
  Delete,
  Done,
  LocalGasStation,
  Waves,
  FilterHdr,
  LocalLaundryService,
  BrandingWatermark,
  Visibility,
} from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { parseISO, format, parse, subDays } from 'date-fns';
import { isNull, isArray } from 'lodash';
import qs from 'querystring';

import { t, number, dataHora, hora, can, canURL } from '~/helpers';
import { visualizarCO } from '~/helpers/reportUtils';
import api from '~/services/api';
import { DateTime } from '~/components/Form';

import { Tabela } from './components';
import AbastecimentoPitStop from './components/Atendimento/Abastecimento';
import AreiaPitStop from './components/Atendimento/Areia';
import BanheiroPitStop from './components/Atendimento/Banheiro';
import AguaPitStop from './components/Atendimento/Agua';
import LimpezaPitStop from './components/Atendimento/Limpeza';
import LubrificacaoPitStop from './components/Atendimento/Lubrificacao';
import SelMovimentacaoPitStop from './components/Atendimento/SelMovimentacao';
import EdicaoFimPitStop from './components/EdicaoFim';
import EdicaoInicioPitStop from './components/EdicaoInicio';
import ExcluirPitStop from './components/Excluir';
import FimPitStop from './components/Fim';
import InicioPitStop from './components/Inicio';

import { MODULO_CUSTOMIZACAO_RUMO } from '~/constants/modules';

function PitStop() {
  const [load, setLoad] = React.useState(false);
  const [postos, setPostos] = React.useState([]);
  const [idposto, setIdPosto] = React.useState(null);
  const [idturno, setIdturno] = React.useState(null);
  const [slapitstopposto, setSlapitstopposto] = React.useState(null);
  const [datahorainicialturno, setDatahorainicialturno] = React.useState(null);
  const [datahorafinalturno, setDatahorafinalturno] = React.useState(null);
  const [atendimentos, setAtendimentos] = React.useState([]);
  const [abastecimentos, setAbastecimentos] = React.useState([]);
  const [lubrificacoes, setLubrificacoes] = React.useState([]);
  const [posto, setPosto] = React.useState(null);
  const [modoRetroativo, setModoRetroativo] = React.useState(false);
  const [turnosRetroativos, setTurnosRetroativos] = React.useState([]);
  const [turnoRetroativo, setTurnoRetroativo] = React.useState(null);
  const [dataInicialRetroativa, setDataInicialRetroativa] = React.useState(
    format(subDays(new Date(), 7), 'dd/MM/yyyy HH:mm:ss')
  );
  const [dataFinalRetroativa, setDataFinalRetroativa] = React.useState(
    format(new Date(), 'dd/MM/yyyy HH:mm:ss')
  );
  //
  const data = useSelector((state) => state.pitStop);
  // forms
  const inicioPitStopRef = React.useRef(null);
  const fimPitStopRef = React.useRef(null);
  const edicaoInicioPitStopRef = React.useRef(null);
  const edicaoFimPitStopRef = React.useRef(null);
  const exibirAbastecimentoPitStopRef = React.useRef(null);
  const exibirLubrificacaoPitStopRef = React.useRef(null);
  const exibirSelMovimentacaoPitStopRef = React.useRef(null);
  const exibirAreiaPitStopRef = React.useRef(null);
  const exibirLimpezaPitStopRef = React.useRef(null);
  const exibirBanheiroPitStopRef = React.useRef(null);
  const exibirAguaPitStopRef = React.useRef(null);
  const deleteRef = React.useRef(null);
  //
  const [parametros, setParametros] = React.useState(null);
  const [viewAtendimentos, setViewAtendimentos] = React.useState(true);
  const [viewAbastecimentos, setViewAbastecimentos] = React.useState(false);
  //
  const [janelaAberta, setJanelaAberta] = React.useState(false);

  const handleUpdate = (result) => {
    handleGetDataTable(result.idturno);
    setJanelaAberta(false);
  };

  const handleClose = () => {
    setJanelaAberta(false);
  };

  useEffect(() => {
    if (postos && postos.length === 1) {
      setPosto(postos[0]);
      handleChangeAutocomplete(postos[0]);
    }
  }, [postos]);

  const execucao = useMemo(
    () => [
      { label: '0', value: '' },
      { label: 'N', value: t('s.geral.opcoes.nao') },
      { label: 'S', value: t('s.geral.opcoes.sim') },
      { label: 'X', value: t('s.geral.opcoes.na') },
    ],
    []
  );

  const tipoLocomotiva = useMemo(() => [
    { label: 'L', value: t('s.geral.opcoes.locomotiva') },
    { label: 'O', value: t('s.geral.opcoes.outros') },
  ]);

  const headerAtendimento = useMemo(() => {
    const data = [
      {
        id: 'codigoatendimento',
        label: t('s.cadastro.pitstop.codigoatendimento'),
        align: 'left',
      },
      {
        id: 'dataencosteatendimento',
        label: t('s.cadastro.pitstop.dataencosteatendimento'),
        format: (value) => dataHora(value),
      },
      {
        id: 'dataliberacaoatendimento',
        label: t('s.cadastro.pitstop.dataliberacaoatendimento'),
        align: 'left',
        format: (value) => hora(value),
      },
      {
        id: 'idveiculo',
        label: t('s.menu.cadastro.veiculo.locomotiva'),
      },
      {
        id: 'slaatendimento',
        label: t('s.cadastro.pitstop.slaatendimento'),
      },
      {
        id: 'nomeusuarioresponsavel',
        label: t('s.cadastro.pitstop.nomeusuarioresponsavel'),
      },
      {
        id: 'abastecimento',
        label: t('s.cadastro.pitstop.abastecimento'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: execucao },
        styledIcon: (value) =>
          value === 'S'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 'N'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ff0000',
              }
            : value === 'X'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ffbf00',
              }
            : {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#999999',
              },
        action: [
          {
            label: t('s.cadastro.pitstop.abastecimento'),
            botao: LocalGasStation,
            edicao: 'abastecimento',
            origem: 'A',
          },
        ],
      },
      {
        id: 'lubrificacao',
        label: t('s.cadastro.pitstop.lubrificacao'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: execucao },
        styledIcon: (value) =>
          value === 'S'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 'N'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ff0000',
              }
            : value === 'X'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ffbf00',
              }
            : {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#999999',
              },
        action: [
          {
            label: t('s.cadastro.pitstop.lubrificacao'),
            botao: Waves,
            edicao: 'lubrificacao',
            origem: 'L',
          },
        ],
      },
      {
        id: 'areia',
        label: t('s.cadastro.pitstop.areia'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: execucao },
        styledIcon: (value) =>
          value === 'S'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 'N'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ff0000',
              }
            : value === 'X'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ffbf00',
              }
            : {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#999999',
              },
        action: [
          {
            label: t('s.cadastro.pitstop.areia'),
            botao: FilterHdr,
            edicao: 'areia',
          },
        ],
      },
      {
        id: 'limpeza',
        label: t('s.cadastro.pitstop.limpeza'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: execucao },
        styledIcon: (value) =>
          value === 'S'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 'N'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ff0000',
              }
            : value === 'X'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ffbf00',
              }
            : {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#999999',
              },
        action: [
          {
            label: t('s.cadastro.pitstop.limpeza'),
            botao: LocalLaundryService,
            edicao: 'limpeza',
          },
        ],
      },
      {
        id: 'acao',
        label: t('s.relatorio.auditoria.acaoauditoriasistema'),
        action: [
          {
            label: t('s.cadastro.pitstop.atendimento'),
            botao: Visibility,
            edicao: 'emitir',
          },
          {
            label: t('s.geral.botaofechar'),
            botao: Done,
            edicao: 'fim',
          },
          {
            label: t('s.geral.botaoalterar'),
            botao: Edit,
            edicao: 'editar',
          },
          {
            label: t('s.geral.botaoexcluir'),
            botao: Delete,
            edicao: 'excluir',
          },
        ],
      },
    ];

    if (can(MODULO_CUSTOMIZACAO_RUMO)) {
      data.splice(10, 0, {
        id: 'banheiro',
        label: t('s.cadastro.pitstop.banheiro'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: execucao },
        styledIcon: (value) =>
          value === 'S'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 'N'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ff0000',
              }
            : value === 'X'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ffbf00',
              }
            : {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#999999',
              },
        action: [
          {
            label: t('s.cadastro.pitstop.banheiro'),
            botao: BrandingWatermark,
            edicao: 'banheiro',
          },
        ],
      });
    } else {
      data.splice(10, 0, {
        id: 'agua',
        label: t('s.cadastro.pitstop.aguabanheiro'),
        format: (value) => {
          const option = execucao.find((s) => s.label === value);
          return option ? option.value : '';
        },
        filter: { type: 'select', options: execucao },
        styledIcon: (value) =>
          value === 'S'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 'N'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ff0000',
              }
            : value === 'X'
            ? {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#ffbf00',
              }
            : {
                marginLeft: value ? 8 : 0,
                cursor: 'pointer',
                color: '#999999',
              },
        action: [
          {
            label: t('s.cadastro.pitstop.aguabanheiro'),
            botao: BrandingWatermark,
            edicao: 'agua',
          },
        ],
      });
    }

    return data;
  }, [t]);

  const headerMovimentacao = useMemo(() => {
    const data = [
      {
        id: 'idveiculo',
        label: t('s.menu.cadastro.veiculo.locomotiva'),
        align: 'left',
      },
      {
        id: 'datahorainicialmovimentacao',
        label: t('s.cadastro.pitstop.dataencosteatendimento'),
        format: (value) => dataHora(value),
      },
      {
        id: 'datahorafinalmovimentacao',
        label: t('s.cadastro.pitstop.dataliberacaoatendimento'),
        align: 'left',
        format: (value) => hora(value),
      },
      {
        id: 'idbico',
        label: t('s.menu.configuracao.bico'),
        align: 'left',
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.abastecimento.volumemovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'encerranteinicialmovimentacao',
        label: t('s.geral.camposistema.encerranteinicialmovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'encerrantefinalmovimentacao',
        label: t('s.geral.camposistema.encerrantefinalmovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'tipolocomotivaveiculo',
        label: t('s.cadastro.veiculo.tipolocomotivaveiculo'),
        format: (value) =>
          tipoLocomotiva.find((s) => s.label === value).value || '',
      },
      {
        id: 'acao',
        label: t('s.relatorio.auditoria.acaoauditoriasistema'),
        align: 'left',
        action: [
          {
            label: t('s.geral.botaoincluir'),
            botao: Done,
            edicao: 'iniciamovimentacao',
          },
        ],
      },
    ];

    if (can(MODULO_CUSTOMIZACAO_RUMO)) {
    }

    return data;
  }, [t]);

  React.useEffect(() => {
    handleGetPostosComboios();
  }, []);

  const handleGetPostosComboios = React.useCallback(async () => {
    setLoad(true);
    try {
      const { data } = await api.get('postoscomboios', {
        params: {
          pagesize: 9999,
          wherefield: ['statusposto', 'controlapitstopposto'],
          typewherefield: ['EQUALS', 'EQUALS'],
          valuewherefield: ['L', 'S'],
          orderfield: 'nomeposto',
          ordination: '',
          pesquisalista: true,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });
      setPostos(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  /*
   *  wherefield: ['id', 'nome', etc...],
   *  typewherefield: ['EQUALS', 'EQUALS', etc..],
   *  valuewherefield: [1, 'Fulano', etc..],
   */

  const handleChangeAutocomplete = React.useCallback(
    (value) => {
      if (isNull(value)) {
        handleResetVars();
      } else {
        const {
          idposto,
          idturno,
          datahorainicialturno,
          datahorafinalturno,
          slapitstopposto,
        } = value;
        setPosto(value);
        setIdPosto(idposto);
        setIdturno(idturno);
        setDatahorainicialturno(datahorainicialturno);
        setDatahorafinalturno(datahorafinalturno);
        setSlapitstopposto(slapitstopposto);
        // carrega os dados
        handleGetDataTable(idturno);
      }
    },
    [idposto]
  );

  const handleResetVars = React.useCallback(() => {
    setPosto(null);
    setIdPosto(null);
    setIdturno(null);
    setDatahorainicialturno(null);
    setDatahorafinalturno(null);
    setSlapitstopposto(null);
    setAtendimentos([]);
    setAbastecimentos([]);
    setLubrificacoes([]);
    setTurnosRetroativos([]);
    setTurnoRetroativo(null);
  }, []);

  const handleGetDataTable = React.useCallback(async (idturno) => {
    try {
      if (idturno) {
        setLoad(true);
        const { data } = await api.get(`pitstop/turno/${idturno}`);
        // atendimentos
        const l = data.atendimentos.map((atendimento) => ({
          ...atendimento,
        }));
        const list = l.map((row) => ({
          ...row,
          atendimentoFechado: row.dataliberacaoatendimento != null ? 'S' : 'N',
        }));
        setAtendimentos(list);
        // abastecimentos
        const abas = data.abastecimentos.map((movimentacao) => ({
          ...movimentacao,
        }));
        const movsAbas = abas.map((row) => ({
          ...row,
          atendimentoFechado: 'N',
        }));
        setAbastecimentos(movsAbas);
        // lubrificacoes
        const lubs = data.lubrificacoes.map((movimentacao) => ({
          ...movimentacao,
        }));
        const movsLubs = lubs.map((row) => ({
          ...row,
          atendimentoFechado: 'N',
        }));
        setLubrificacoes(movsLubs);
      } else {
        setAtendimentos([]);
        setAbastecimentos([]);
        setLubrificacoes([]);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
      handleResetVars();
    } finally {
      setLoad(false);
    }
  }, []);

  const handleConsultaTurnosRetroativos = React.useCallback(
    async (
      dataInicial = dataInicialRetroativa,
      dataFinal = dataFinalRetroativa
    ) => {
      if (!idposto || !dataInicial || !dataFinal) return;

      const inicio = parse(dataInicial, 'dd/MM/yyyy HH:mm:ss', new Date());
      const fim = parse(dataFinal, 'dd/MM/yyyy HH:mm:ss', new Date());

      if (fim < inicio) {
        toast.error('A data/hora final deve ser maior ou igual à inicial.');
        return;
      }

      try {
        setLoad(true);
        const { data } = await api.get('pitstop/turnosretroativos', {
          params: {
            idposto,
            datainicial: format(inicio, 'yyyy-MM-dd'),
            datafinal: format(fim, 'yyyy-MM-dd'),
          },
        });
        setTurnosRetroativos(data);
        setTurnoRetroativo(null);
        setIdturno(null);
        setAtendimentos([]);
        setAbastecimentos([]);
        setLubrificacoes([]);
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoad(false);
      }
    },
    [idposto, dataInicialRetroativa, dataFinalRetroativa]
  );

  const handleSelecionaTurnoRetroativo = React.useCallback(
    (turno) => {
      setTurnoRetroativo(turno);
      if (!turno) {
        setIdturno(null);
        setAtendimentos([]);
        setAbastecimentos([]);
        setLubrificacoes([]);
        return;
      }

      setIdturno(turno.idturno);
      setDatahorainicialturno(turno.horaturno);
      setDatahorafinalturno(null);
      handleGetDataTable(turno.idturno);
    },
    [handleGetDataTable]
  );

  const handleAlternaModoRetroativo = React.useCallback(() => {
    if (modoRetroativo) {
      setModoRetroativo(false);
      setTurnosRetroativos([]);
      setTurnoRetroativo(null);
      handleChangeAutocomplete(posto);
      return;
    }

    setModoRetroativo(true);
    setIdturno(null);
    setDatahorainicialturno(null);
    setDatahorafinalturno(null);
    setAtendimentos([]);
    setAbastecimentos([]);
    setLubrificacoes([]);
    handleConsultaTurnosRetroativos();
  }, [
    modoRetroativo,
    posto,
    handleChangeAutocomplete,
    handleConsultaTurnosRetroativos,
  ]);

  const handleOpenModalInicio = React.useCallback(() => {
    setJanelaAberta(true);
    const data = {
      idposto,
      idturno,
      datahorainicialturno,
    };
    inicioPitStopRef.current.handleToggleModal(data);
  }, [idposto, idturno, datahorainicialturno]);

  const handleOpenModalInicioMovimentacao = React.useCallback(
    (idveiculo, idmovimentacao, tipolocomotivaveiculo) => {
      setJanelaAberta(true);
      const data = {
        idposto,
        idturno,
        datahorainicialturno,
        idveiculo,
        idmovimentacao,
        movimentacaoinicial: true,
        origem: viewAbastecimentos ? 'D' : 'L',
        tipolocomotivaveiculo,
      };
      inicioPitStopRef.current.handleToggleModal(data);
    },
    [idposto, idturno, datahorainicialturno, viewAbastecimentos]
  );

  const handleChangeView = React.useCallback(
    (origem) => {
      if (origem === 'A') {
        setViewAtendimentos(true);
        setViewAbastecimentos(false);
      } else if (origem === 'D') {
        setViewAtendimentos(false);
        setViewAbastecimentos(true);
      } else {
        setViewAtendimentos(false);
        setViewAbastecimentos(false);
      }
    },
    [atendimentos, abastecimentos, lubrificacoes]
  );

  const handleOpenModal = (
    act,
    estaFechado,
    key,
    idveiculo,
    origem = null,
    idmovimentacao = null,
    tipolocomotivaveiculo = null
  ) => {
    setJanelaAberta(true);
    const data = {
      idatendimento: key,
      idposto,
      idturno,
      datahorainicialturno,
      datahorafinalturno,
      slapitstopposto,
      idveiculo,
      origem,
      idmovimentacao,
      tipolocomotivaveiculo,
    };
    setParametros(data);
    if (act === 'fim') {
      fimPitStopRef.current.handleToggleModal(data);
    } else if (act === 'editar') {
      if (estaFechado === 'S') {
        edicaoFimPitStopRef.current.handleToggleModal(data);
      } else {
        edicaoInicioPitStopRef.current.handleToggleModal(data);
      }
    } else if (act === 'abastecimento') {
      abreTelaAbastecimento(data);
    } else if (act === 'lubrificacao') {
      abreTelaLubrificacao(data);
    } else if (act === 'areia') {
      exibirAreiaPitStopRef.current.handleToggleModal(data);
    } else if (act === 'limpeza') {
      exibirLimpezaPitStopRef.current.handleToggleModal(data);
    } else if (act === 'banheiro') {
      exibirBanheiroPitStopRef.current.handleToggleModal(data);
    } else if (act === 'agua') {
      exibirAguaPitStopRef.current.handleToggleModal(data);
    } else if (act === 'excluir') {
      deleteRef.current.handleToggleModal(data);
    } else if (act === 'emitir') {
      visualizarCO(data.idatendimento, api.defaults.headers.token);
    } else if (act === 'iniciamovimentacao') {
      handleOpenModalInicioMovimentacao(
        data.idveiculo,
        data.idmovimentacao,
        data.tipolocomotivaveiculo
      );
    }
  };

  const verificaDadosAbastecimento = React.useCallback(async (data) => {
    try {
      setJanelaAberta(true);
      setLoad(true);
      const resp = await api.get(
        `pitstop/abastecimento/${data.idatendimento}/${data.idposto}`
      );
      if (resp.data) {
        exibirAbastecimentoPitStopRef.current.handleToggleModal(data);
      } else if (resp.atendeuatendimentoabastecimento !== 'N') {
        exibirSelMovimentacaoPitStopRef.current.handleToggleModal(data);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  async function abreTelaAbastecimento(data) {
    verificaDadosAbastecimento(data);
  }

  const verificaDadosLubrificacao = React.useCallback(async (data) => {
    try {
      setJanelaAberta(true);
      setLoad(true);
      const resp = await api.get(
        `pitstop/lubrificacao/${data.idatendimento}/${data.idposto}`
      );
      if (resp.data) {
        exibirLubrificacaoPitStopRef.current.handleToggleModal(data);
      } else {
        exibirSelMovimentacaoPitStopRef.current.handleToggleModal(data);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  async function abreTelaLubrificacao(data) {
    verificaDadosLubrificacao(data);
  }

  const handleUpdateMovimentacao = (idmovimentacao, origem) => {
    if (idmovimentacao > 0) {
      setJanelaAberta(true);
      const novoParam = {
        ...parametros,
        idmovimentacao,
      };
      setParametros(novoParam);
      if (origem === 'A') {
        exibirAbastecimentoPitStopRef.current.handleToggleModal(novoParam);
      } else {
        exibirLubrificacaoPitStopRef.current.handleToggleModal(novoParam);
      }
    } else {
      handleUpdate();
    }
  };

  async function registraSemMovimentacao(
    idatendimento,
    origem,
    justificativas = '',
    obs = '',
    atendeu = '',
    idposto
  ) {
    try {
      const { data } = await api.put(
        `pitstop/atendimento/movimentacao/${idatendimento}/${idposto}/${origem}/${atendeu}/${obs}/${justificativas}`
      );
      toast.success(t('s.geral.sucessoalteracao'));
      handleGetDataTable(idturno);
      setJanelaAberta(false);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    const isTime = setInterval(() => {
      if (!janelaAberta) {
        handleGetDataTable(idturno);
      }
    }, 60000);

    return () => clearInterval(isTime);
  }, [idturno, janelaAberta]);

  function handleSerializeForm(params) {
    return {
      ...params,
    };
  }

  const renderActionButtons = (retroativo) => {
    const habilitado = retroativo ? idposto : idposto && idturno;
    if (!habilitado) return null;

    return (
      <Grid
        item
        xs={12}
        md={12}
        lg={retroativo ? 12 : 8}
        container
        spacing={1}
        justifyContent={retroativo ? 'flex-end' : 'flex-end'}
      >
        <Grid item xs={6} sm={12} md="auto">
          {canURL().pitstop_retroativo && (
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={handleAlternaModoRetroativo}
            >
              {retroativo
                ? t('s.operacao.pitstop.atual')
                : t('s.operacao.pitstop.retroativo')}
            </Button>
          )}
        </Grid>
        <Grid item xs={6} sm={12} md="auto">
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={isNull(idposto) || isNull(idturno)}
            onClick={() => handleChangeView('A')}
            style={{
              backgroundColor:
                viewAtendimentos && !viewAbastecimentos ? 'blue' : 'white',
              color: viewAtendimentos && !viewAbastecimentos ? 'white' : 'blue',
            }}
          >
            {t('s.cadastro.pitstop.atendimentos')}: {atendimentos.length}
          </Button>
        </Grid>
        <Grid item xs={6} sm={12} md="auto">
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={isNull(idposto) || isNull(idturno)}
            onClick={() => handleChangeView('D')}
            style={{
              backgroundColor:
                !viewAtendimentos && viewAbastecimentos ? 'blue' : 'white',
              color: !viewAtendimentos && viewAbastecimentos ? 'white' : 'blue',
            }}
          >
            {t('s.operacao.turno.abastecimentos')}: {abastecimentos.length}
          </Button>
        </Grid>
        <Grid item xs={6} sm={12} md="auto">
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={isNull(idposto) || isNull(idturno)}
            onClick={() => handleChangeView('L')}
            style={{
              backgroundColor:
                !viewAtendimentos && !viewAbastecimentos ? 'blue' : 'white',
              color:
                !viewAtendimentos && !viewAbastecimentos ? 'white' : 'blue',
            }}
          >
            {t('s.cadastro.pitstop.lubrificacoes')}: {lubrificacoes.length}
          </Button>
        </Grid>
        <Grid item xs={6} sm={12} md="auto">
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={isNull(idposto) || isNull(idturno)}
            onClick={handleOpenModalInicio}
            fullWidth={false}
          >
            {t('s.geral.botaoincluir')}
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {load && <LinearProgress />}
      {!modoRetroativo ? (
        <Grid
          container
          spacing={2}
          padding={2}
          alignItems="center"
          style={{ marginTop: '5px' }}
        >
          <Grid item xs={12} sm={10} md={12} lg={4}>
            <Autocomplete
              options={postos}
              value={posto}
              getOptionLabel={(posto) => {
                const fmt = posto.datahorainicialturno
                  ? format(
                      parseISO(posto.datahorainicialturno),
                      'dd/MM/yyyy HH:mm'
                    )
                  : '';
                return `${posto.codigonomeposto} - SLA: ${posto.slapitstopposto} - turno: ${fmt}`;
              }}
              size="small"
              style={{ width: '100%' }}
              fullWidth
              onChange={(e, value) => handleChangeAutocomplete(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('s.operacao.abastecimento.nomeposto')}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          {renderActionButtons(false)}
          {!idposto && (
            <Grid item xs={12} sm="auto" style={{ marginLeft: 'auto' }}>
              <Button
                size="small"
                variant="outlined"
                color="primary"
                disabled={isNull(idposto) || isNull(idturno)}
                onClick={handleOpenModalInicio}
                fullWidth={false}
              >
                {t('s.geral.botaoincluir')}
              </Button>
            </Grid>
          )}
        </Grid>
      ) : (
        <Grid
          container
          spacing={2}
          padding={2}
          alignItems="center"
          style={{ marginTop: '5px' }}
        >
          <Grid item xs={12}>
            <Unform
              initialData={{
                dataInicialRetroativa,
                dataFinalRetroativa,
              }}
              onSubmit={() => {}}
              style={{ width: '100%' }}
            >
              <Grid container spacing={2} padding={2} alignItems="center">
                <Grid item xs={12} sm={4} md={3} lg={2}>
                  <TextField
                    label={t('s.operacao.abastecimento.nomeposto')}
                    value={posto ? posto.codigonomeposto : ''}
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <DateTime
                    name="dataInicialRetroativa"
                    label="Data/Hora Inicial"
                    time
                    nullable
                    defaultValue={dataInicialRetroativa}
                    maxDate={new Date()}
                    getValue={setDataInicialRetroativa}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <DateTime
                    name="dataFinalRetroativa"
                    label="Data/Hora Final"
                    time
                    nullable
                    defaultValue={dataFinalRetroativa}
                    maxDate={new Date()}
                    getValue={setDataFinalRetroativa}
                  />
                </Grid>
                <Grid item xs={12} sm="auto">
                  <Button
                    type="button"
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() =>
                      handleConsultaTurnosRetroativos(
                        dataInicialRetroativa,
                        dataFinalRetroativa
                      )
                    }
                  >
                    Consultar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <Autocomplete
                    options={turnosRetroativos}
                    value={turnoRetroativo}
                    getOptionLabel={(turno) => {
                      return turno
                        ? `${turno.numeroturno} - ${turno.horaturno}`
                        : '';
                    }}
                    onChange={(e, value) =>
                      handleSelecionaTurnoRetroativo(value)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t('s.menu.operacao.turno')}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Unform>
          </Grid>
          {renderActionButtons(true)}
        </Grid>
      )}
      <Tabela
        title={
          viewAtendimentos
            ? t('s.cadastro.pitstop.atendimentos')
            : viewAbastecimentos
            ? t('s.operacao.turno.abastecimentos')
            : t('s.cadastro.pitstop.lubrificacoes')
        }
        cells={viewAtendimentos ? headerAtendimento : headerMovimentacao}
        data={
          viewAtendimentos
            ? atendimentos
            : viewAbastecimentos
            ? abastecimentos
            : lubrificacoes
        }
        height="80vh"
        size="small"
        onIconClick={handleOpenModal}
      />
      {/* criacao edicao */}
      <InicioPitStop
        ref={inicioPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="InicioPitStop"
      />
      <FimPitStop
        ref={fimPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="FimPitStop"
      />
      <EdicaoInicioPitStop
        ref={edicaoInicioPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="EdicaoInicioPitStop"
      />
      <EdicaoFimPitStop
        ref={edicaoFimPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="EdicaoFimPitStop"
      />
      {/* atendimentos */}
      <AbastecimentoPitStop
        ref={exibirAbastecimentoPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="AbastecimentoPitStop"
      />
      {/* seleciona movimentacao */}
      <SelMovimentacaoPitStop
        ref={exibirSelMovimentacaoPitStopRef}
        seleciona={handleUpdateMovimentacao}
        update={handleUpdate}
        close={handleClose}
        name="SelMovimentacaoPitStop"
      />
      {/* lubrificacao */}
      <LubrificacaoPitStop
        ref={exibirLubrificacaoPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="LubrificacaoPitStop"
      />
      {/* Areia */}
      <AreiaPitStop
        ref={exibirAreiaPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="AreiaPitStop"
      />
      {/* Limpeza */}
      <LimpezaPitStop
        ref={exibirLimpezaPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="LimpezaPitStop"
      />
      {/* Banheiro */}
      <BanheiroPitStop
        ref={exibirBanheiroPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="BanheiroPitStop"
      />
      {/* agua */}
      <AguaPitStop
        ref={exibirAguaPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="AguaPitStop"
      />
      {/* exclusao */}
      <ExcluirPitStop
        ref={deleteRef}
        update={handleUpdate}
        close={handleClose}
        name="ExcluirPitStop"
      />
    </>
  );
}

export default PitStop;
